import { Link, Typography } from "@mui/material"
import useAppStore from "store/app"

const ForgotPassword = () => {
  const t = useAppStore((state) => state.translations)

  return (
    <Link sx={{ cursor: "pointer", textDecoration: "none" }} href="/reset_password">
      <Typography variant="body2" sx={{ my: 2, fontWeight: 500 }}>
        {t?.data?.pages?.login_page?.forgot_password}
      </Typography>
    </Link>
  )
}

export default ForgotPassword
